const conditions = {
  bindings: {
  },
  templateUrl: '/modules/pis-tool/conditions/conditions.html',
  controller: 'ConditionsController',
};

angular
  .module('pis-tool.module')
  .component('conditions', conditions)
  .config(function($stateProvider) {
      $stateProvider.state('pis.workspaces.conditions', {
          url: '/conditions',
          views: {
              'pisview@pis': 'conditions',
          },
          resolve: {
              // workSpaces: PISService => PISService.getAllWorkspaces(),
          },
      });
  });
